import * as Joi from 'joi';
import { KeyValueResponse } from '../../../../../api-refactored/typings';

export interface AeisExamFeeFormData {
  gstPercent: number;
  gstInclusive: string;
  registrationFee: number;
  lateRegistrationFee: number;
  admissionLevelCodes: KeyValueResponse[];
}

export const AeisExamFeeSchema = Joi.object({
  gstPercent: Joi.number().required().max(999.99).messages({
    'any.required': `GST Percent is not allowed to be empty.`,
    'number.base': `GST Percent is not allowed to be empty.`,
    'number.max': `GST Percent is not allowed to more than 3 digit.`,
  }),
  gstInclusive: Joi.string().required().messages({
    'any.required': `Please select if GST is inclusive.`,
  }),
  registrationFee: Joi.number().required().max(99999.99).messages({
    'any.required': `Registration Fee is not allowed to be empty.`,
    'number.base': `Registration Fee is not allowed to be empty.`,
    'number.max': `Registration Fee is not allowed to more than 5 digit.`,
  }),
  lateRegistrationFee: Joi.number().required().max(99999.99).messages({
    'any.required': `Late Registration Fee is not allowed to be empty.`,
    'number.base': `Late Registration Fee is not allowed to be empty.`,
    'number.max': `Late Registration Fee is not allowed to more than 5 digit.`,
  }),
  admissionLevelCodes: Joi.array().items(Joi.object()).has(Joi.object()).messages({
    'array.hasUnknown': 'Please select admission level.',
  }),
});
